/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type interiorsModuleHelpers_interiorPhotos = {
    readonly photoSearchParam: {
        readonly name: string | null;
    } | null;
    readonly " $refType": "interiorsModuleHelpers_interiorPhotos";
};
export type interiorsModuleHelpers_interiorPhotos$data = interiorsModuleHelpers_interiorPhotos;
export type interiorsModuleHelpers_interiorPhotos$key = {
    readonly " $data"?: interiorsModuleHelpers_interiorPhotos$data;
    readonly " $fragmentRefs": FragmentRefs<"interiorsModuleHelpers_interiorPhotos">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "interiorsModuleHelpers_interiorPhotos"
};
(node as any).hash = '983cc22422edafbc44eb8baaeff21fa7';
export default node;
